import { withTheme } from 'styled-components'
import Icon from './Icon'

export default withTheme(Icon)
